
import { defineComponent, reactive, toRefs } from "vue";
import { clone, parseError } from "@/generic";
import {
  useUpdateOnePriceLabelParamMutation,
  useGetOnePriceLabelParamQuery,
} from "@/client/modules/api";
import { InputCurrency } from "@/generic/components/entry";
import { message } from "ant-design-vue";

export type Props = {
  priceLabelParamId: string;
};

export default defineComponent({
  components: {
    InputCurrency,
  },
  props: {
    priceLabelParamId: {
      type: String,
      required: true,
    },
  },
  setup(props: Props) {
    const state = reactive({
      priceLabelParam: null as null | any,
      visibleParamInput: false,
      errorMessages: [] as string[],
    });

    const { loading, onResult, refetch } = useGetOnePriceLabelParamQuery(
      {
        id: props.priceLabelParamId,
      },
      {
        fetchPolicy: "network-only",
      }
    );
    onResult((result) => {
      state.priceLabelParam = clone(result.data.priceLabelParam);
    });

    const handleVisibleParamInput = () => {
      state.visibleParamInput = true;
    };

    const { mutate: update, error: updateError } =
      useUpdateOnePriceLabelParamMutation({});

    const handleUpdate = async () => {
      const safePriceLabelParam = state.priceLabelParam;
      try {
        if (safePriceLabelParam == null) return;
        state.errorMessages = [];
        await update({
          input: {
            id: props.priceLabelParamId,
            janCode: safePriceLabelParam.janCode,
            taxIncludedPrice: safePriceLabelParam.taxIncludedPrice,
          },
        });

        await refetch();
      } catch (e) {
        if (updateError.value == null) throw e;
        const errorMessages = parseError(updateError.value);
        errorMessages.forEach((msg: string) => message.error(msg));
      }
    };

    const handleClose = () => {
      state.visibleParamInput = false;
    };

    return {
      ...toRefs(state),
      loading,
      handleVisibleParamInput,
      handleUpdate,
      handleClose,
    };
  },
});
